module.exports = __webpack_public_path__ + "img/Infinity8_pdf.3cfa5f5b.png";